import { FormArray, FormControl } from '@angular/forms';
import { MessageCategory } from '@core-lib/enums';

export interface IMessageBase {
	id?: string;
	carpaId?: string;
	editDate?: Date;
	startDate: Date;
	endDate: Date;
	bo: boolean;
	fo: boolean;
	apiExt: boolean;
	applicatifs?: string;
	carpaIds: string[];
	displayOnce: boolean;
	displayOnPage: boolean;
	blockConnection: boolean;
	content: string;
	version?: string;
	category: MessageCategory;
}
export interface IMessage extends IMessageBase {
	attachments?: IMessageAttach[];
}
export interface IMessageRequest extends IMessageBase {
	attachments?: IMessageAttachForRequest[];
}
export interface IMessageForm {
	startDate: FormControl<Date>;
	endDate: FormControl<Date>;
	bo: FormControl<boolean>;
	fo: FormControl<boolean>;
	apiExt: FormControl<boolean>;
	allCarpas: FormControl<string>;
	carpas: FormControl<string[]>;
	displayOnce: FormControl<boolean>;
	displayOnPage: FormControl<boolean>;
	blockConnection: FormControl<boolean>;
	fileArray: FormArray;
	content: FormControl<string>;
	version?: FormControl<string>;
}
export interface IMessageAttach {
	ressourceId: string;
	fileName: string;
	size?: number;
	downloadUrl?: string;
}

export interface IMessageAttachForRequest {
	ressourceId: string;
	fileName: string;
	isNew: boolean;
}

export interface IMessageAttachRequest {
	messageId?: string;
	origin: IMessageAttachForRequest[];
	fileArray: File[];
}

export enum MessageTargetCarpas {
	All = 'all',
	AllExceptParis = 'allExceptParis',
	Selected = 'selected'
}
